import EditButton from '@/features/common/components/InsertNoteFormContent/Switcher/parts/Note/parts/EditButton'
import Text from '@/features/common/components/InsertNoteFormContent/Switcher/parts/Note/parts/Text'
import Title from '@/features/common/components/InsertNoteFormContent/Switcher/parts/Note/parts/Title'
import { FC } from 'react'
import { View } from 'react-native'

interface NoteProps {
    children: string
    onEdit: () => void
}

const Note: FC<NoteProps> = ({ children, onEdit }) => {
    return (
        <View style={{ gap: 8 }}>
            <Title />
            <View style={{ flexDirection: 'row', gap: 16 }}>
                <Text>{children}</Text>
                <EditButton onPress={onEdit} />
            </View>
        </View>
    )
}

export default Note
